import { BaseApiService } from "./baseApiService";
import type { BaseResponse, PolicyDocument } from "../types/api";

export interface DocumentTypesResponse extends BaseResponse {
  data: Array<{ key: string; value: string }>;
  total: number;
}

export interface DocumentsByTypeParams {
  document_type: string;
  page?: number;
  limit?: number;
}

export interface DocumentsByTypeResponse extends BaseResponse {
  data: PolicyDocument[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  document_type: string;
}

class DocumentApiService extends BaseApiService {
  // Get available document types
  async getDocumentTypes(): Promise<DocumentTypesResponse> {
    const url = `/api/v1/document-types`;

    const response = await BaseApiService.get({ url });

    if (response.success) {
      return response as unknown as DocumentTypesResponse;
    } else {
      throw new Error(response.error || "Failed to fetch document types");
    }
  }

  // Get documents by document type
  async getDocumentsByType(
    params: DocumentsByTypeParams
  ): Promise<DocumentsByTypeResponse> {
    const queryParams = new URLSearchParams();
    queryParams.append("document_type", params.document_type);
    if (params.page) queryParams.append("page", params.page.toString());
    if (params.limit) queryParams.append("limit", params.limit.toString());

    const url = `/api/v1/documents/by-type?${queryParams.toString()}`;

    const response = await BaseApiService.get({ url });

    if (response.success) {
      return response as unknown as DocumentsByTypeResponse;
    } else {
      throw new Error(response.error || "Failed to fetch documents by type");
    }
  }
}

// Export singleton instance
export const documentApiService = new DocumentApiService();

// Export the class for testing or custom instances
export default DocumentApiService;
